import { mutate } from 'swr';
import { handleApiError } from 'utils/errorHandler';
import { fetcherWithMethod } from 'utils/axios';
import { usePermissionContext } from 'contexts/PermissionContext';
import { CrudEndpoints } from 'types/common';

const endpoints: CrudEndpoints = {
    key: 'UserManagement/AuthorizeUser',
    getList: '/GetList',
    getListById: '/GetList/{ID}',
    getModal: '/',
    getLookupList: '/GetLookupList',
    insert: '/',
    update: '/',
    delete: ''
};

export const useGetPermissions = () => {
    return usePermissionContext();
};

export const useHasAuthorization = async (featureID: number | null, permissions: number | null) => {
    try {
        const response = await fetcherWithMethod('GET', [
            `${endpoints.key}/HasAuthorization/${featureID}/${permissions}`, {}
        ]);

        return response;
    } catch (error: any) {
        // Handle 403 errors specifically for permission checks
        if (error?.response?.status === 403) {
            // Don't show error message for permission checks, just return false
            return false;
        }
        handleApiError(error);
        throw error;
    }
};

// Invalidate cached user permissions (e.g., after role updates)
export const invalidateUserPermissions = () => {
    const endpoint = `${endpoints.key}/GetPermissions`;
    const key = [endpoint, { method: 'GET' }];
    mutate(key);
};